// extracted by mini-css-extract-plugin
export default {"whatsapp_btn":"WhatsAppBtn_whatsapp_btn__uJgyh","whatsapp_icon":"WhatsAppBtn_whatsapp_icon__R-ZHY"};